package tta.destinigo.talktoastro.feature_authentication.persentation.register_page

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.unit.dp
import tta.destinigo.talktoastro.resources.Res
import tta.destinigo.talktoastro.resources.welcome_banner_two
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource
import tta.destinigo.talktoastro.feature_authentication.persentation.register_page.RegisterComponent


@Composable
fun RegisterPage(
    component: RegisterComponent
) {
    var userName by remember { mutableStateOf(TextFieldValue()) }
//    val state by component.state.collectAsState()

    // Use rememberCoroutineScope to launch coroutines
    val coroutineScope = rememberCoroutineScope()

    Column(
        verticalArrangement = Arrangement.Bottom,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier
            .padding(12.dp)
            .fillMaxSize()
    ) {
        Image(
            painter = painterResource(Res.drawable.welcome_banner_two),
            contentDescription = null,
            modifier = Modifier
                .fillMaxHeight(40/100F)
                .fillMaxWidth(),
        )

        Text(
            text = "Create Account",
            style = MaterialTheme.typography.titleMedium,
            modifier = Modifier.padding(top = 16.dp, bottom = 8.dp)
        )

        OutlinedTextField(
            value = userName,
            onValueChange = { userName = it },
            label = { Text("User Name") },
            modifier = Modifier
                .padding(bottom = 8.dp)
                .fillMaxWidth()
                .padding(horizontal = 16.dp)
        )

        // Repeat for other text fields and views...

        Button(
            onClick = {
                coroutineScope.launch {
                    component.onRegisterUser(userName.text,"")
                }
            },
            modifier = Modifier
                .padding(16.dp)
                .fillMaxWidth(),
        ) {
            Text("Register")
        }

        Spacer(modifier = Modifier.height(40.dp))
    }
}